module.exports = __webpack_public_path__ + "static/media/kiwiandkorv.be009e3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/kiwiandkorv.png
// module id = 40
// module chunks = 0